import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Calculator } from 'lucide-react';
import { motion } from 'framer-motion';

export function Contact() {
  return (
    <section id="contact" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16">
          <div>
            <h2 className="section-subheading">Contact</h2>
            <h3 className="section-heading mb-12">Let's Discuss Your Vision</h3>
            
            <div className="space-y-8">
              <div className="flex items-center gap-6">
                <Phone className="h-6 w-6 text-yellow-400" />
                <a href="tel:9149606433" className="text-zinc-400 hover:text-yellow-400 transition-colors">(914) 960-6433</a>
              </div>
              <div className="flex items-center gap-6">
                <Mail className="h-6 w-6 text-yellow-400" />
                <a href="mailto:info@renovationwestchester.com" className="text-zinc-400 hover:text-yellow-400 transition-colors">
                  info@renovationwestchester.com
                </a>
              </div>
            </div>

            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="mt-12 relative group"
            >
              <div className="absolute -inset-1 bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-500 rounded-xl blur-lg opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-pulse"></div>
              <Link
                to="/project-planner"
                className="relative flex items-center gap-4 bg-gradient-to-r from-zinc-900 to-zinc-800 p-6 rounded-xl border border-yellow-400/20 hover:border-yellow-400/40 transition-all duration-300"
              >
                <div className="p-3 bg-yellow-400/10 rounded-lg">
                  <Calculator className="h-8 w-8 text-yellow-400" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl text-zinc-100 mb-1">Try Our Project Planner</h3>
                  <p className="text-zinc-400">Get an instant AI-powered estimate for your project</p>
                </div>
              </Link>
            </motion.div>
          </div>

          <div className="bg-zinc-800/30 p-8 rounded-xl">
            <h4 className="text-xl text-zinc-100 mb-6">Get a Free Consultation</h4>
            <p className="text-zinc-400 mb-8">
              Fill out our consultation form and we'll get back to you within 24 hours.
            </p>
            <Link 
              to="/consultation"
              className="inline-flex items-center gap-2 px-8 py-4 bg-yellow-400 text-zinc-900 hover:bg-yellow-500 transition-colors"
            >
              Schedule Consultation
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}